// Older imports append a timestamp or upload ID after the original extension.
// Inspect only the filename, without the signature, folder names or playback fragment.
export function mediaExtension(value) {
  if (typeof value !== 'string' || !value) return ''
  let pathname = value.split(/[?#]/)[0]
  try { pathname = new URL(value, 'https://media.invalid').pathname } catch (_) { /* Raw object key. */ }
  try { pathname = decodeURIComponent(pathname) } catch (_) { /* Keep malformed encodings unchanged. */ }
  const filename = pathname.split('/').pop().replace(/-(?:\d{8}T\d{9}Z\d*|[a-f0-9]{32}|[a-f0-9]{8}(?:-[a-f0-9]{4}){3}-[a-f0-9]{12})$/i, '')
  const match = filename.match(/\.([a-z0-9]+)$/i)

  return match ? match[1].toLowerCase() : ''
}

export function isVideoUrl(value) {
  return ['mp4', 'mov', 'm4v', 'webm', 'avi', 'mkv', 'flv', 'wmv', 'mpg', 'mpeg'].includes(mediaExtension(value))
}

export function videoMimeType(value) {
  const types = {
    mov: 'video/quicktime',
    mkv: 'video/x-matroska',
    avi: 'video/avi',
    flv: 'video/x-flv',
    wmv: 'video/x-ms-wmv',
    mpg: 'video/mpeg',
    mpeg: 'video/mpeg',
    webm: 'video/webm',
  }

  return types[mediaExtension(value)] || 'video/mp4'
}
